/* NANIMERICA homepage behaviour (sections/nr-home-*). Loaded once per page; each section re-inits on theme-editor load. */
(function () {
  if (window.nrHome) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Tabs: [data-nrh-tabs] > [role=tab][aria-controls] + [role=tabpanel] */
  function tabs(root) {
    root.querySelectorAll('[data-nrh-tabs]').forEach(function (group) {
      if (group.nrReady) return;
      group.nrReady = true;
      var btns = Array.prototype.slice.call(group.querySelectorAll('[role="tab"]'));
      function select(btn, focus) {
        btns.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var p = document.getElementById(b.getAttribute('aria-controls'));
          if (!p) return;
          if (on) {
            p.hidden = false;
            p.classList.remove('is-in');
            void p.offsetWidth;
            p.classList.add('is-in');
            var t = p.querySelector('.nrh-rail__track');
            if (t) { t.scrollLeft = 0; t.dispatchEvent(new Event('scroll')); }
          } else {
            p.hidden = true;
          }
        });
        if (focus) btn.focus();
        var bar = btn.parentElement;
        if (bar && bar.scrollWidth > bar.clientWidth) {
          var left = btn.offsetLeft - (bar.clientWidth - btn.offsetWidth) / 2;
          bar.scrollTo({ left: left, behavior: reduce.matches ? 'auto' : 'smooth' });
        }
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { select(b); });
        b.addEventListener('keydown', function (e) {
          var k = e.key, n = null;
          if (k === 'ArrowRight' || k === 'ArrowDown') n = btns[(i + 1) % btns.length];
          if (k === 'ArrowLeft' || k === 'ArrowUp') n = btns[(i - 1 + btns.length) % btns.length];
          if (k === 'Home') n = btns[0];
          if (k === 'End') n = btns[btns.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }

  /* Rails: arrows scroll by one viewport of cards */
  function rails(root) {
    root.querySelectorAll('.nrh-rail').forEach(function (rail) {
      if (rail.nrReady) return;
      rail.nrReady = true;
      var track = rail.querySelector('.nrh-rail__track');
      var prev = rail.querySelector('.nrh-rail__nav--prev');
      var next = rail.querySelector('.nrh-rail__nav--next');
      if (!track || !prev || !next) return;
      function state() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }
      function go(dir) {
        track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: reduce.matches ? 'auto' : 'smooth' });
      }
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', state, { passive: true });
      window.addEventListener('resize', state);
      state();
    });
  }

  /* Reveal on scroll + count-up numbers */
  var io = null;
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-nrh-count'));
    if (isNaN(target) || reduce.matches) return;
    var dec = (el.getAttribute('data-nrh-count').split('.')[1] || '').length;
    var suffix = el.getAttribute('data-nrh-suffix') || '';
    var start = null, dur = 1400;
    function fmt(v) {
      var s = v.toFixed(dec);
      if (!dec) s = Math.round(v).toLocaleString('en-US');
      return s + suffix;
    }
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * e);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = fmt(target);
    }
    requestAnimationFrame(step);
  }
  function reveal(root) {
    var els = root.querySelectorAll('[data-nrh-reveal]:not(.is-in), [data-nrh-count]:not([data-done])');
    if (!('IntersectionObserver' in window) || reduce.matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          io.unobserve(el);
          if (el.hasAttribute('data-nrh-count')) { el.setAttribute('data-done', ''); countUp(el); }
          else {
            var d = parseInt(el.getAttribute('data-nrh-delay') || '0', 10);
            setTimeout(function () { el.classList.add('is-in'); }, d);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* Review viewer */
  function reviews(root) {
    root.querySelectorAll('[data-nrh-rv]').forEach(function (wrap) {
      if (wrap.nrReady) return;
      wrap.nrReady = true;
      var dlg = wrap.querySelector('dialog');
      if (!dlg || typeof dlg.showModal !== 'function') return;
      var img = dlg.querySelector('[data-img]'), txt = dlg.querySelector('[data-txt]'), who = dlg.querySelector('[data-who]'),
          stars = dlg.querySelector('[data-stars]'), cta = dlg.querySelector('[data-cta]');
      wrap.querySelectorAll('[data-rvc]').forEach(function (card) {
        card.addEventListener('click', function () {
          img.src = card.getAttribute('data-src');
          img.alt = card.getAttribute('data-alt') || '';
          txt.textContent = card.querySelector('template') ? card.querySelector('template').content.textContent : '';
          who.innerHTML = card.querySelector('.nrh-rvc__who').innerHTML;
          stars.style.setProperty('--p', card.getAttribute('data-p') + '%');
          cta.href = card.getAttribute('data-url');
          cta.textContent = 'Shop ' + card.getAttribute('data-product');
          dlg.showModal();
        });
      });
      dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-close]')) dlg.close(); });
    });
  }

  function init(root) {
    root = root || document;
    tabs(root); rails(root); reveal(root); reviews(root);
  }
  window.nrHome = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
